import React from 'react';
import { usePrefixTranslation } from '../../../i18n';
import { actions, useTypedDispatch, useTypedSelector } from '../../../redux';
import { DataMultiDisplayCard } from '../cards/DataMultiDisplayCard';

/**
 * Fetch past due and psm information and render it using a data card.
 */
export const PastDuePsm = () => {
    const { t } = usePrefixTranslation(['dashboard', 'common'], { dashboard: 'metrics.PastDuePsm' });
    const dispatch = useTypedDispatch();
    const { pastDuePsm } = useTypedSelector(state => ({ pastDuePsm: state.stats.pastDuePsm }));
    const colors = { 'past-due': ['#f9a', '#F9F'], psm: ['#95F'] };
    const data = Object.entries(pastDuePsm.stats ?? {}).map(([name, { count, ratio }]) => ({
        name: t(`label-${name}`),
        color: (colors as any)[name],
        main: t('equipment', { count }),
        info: t('plant-percent', { count: ratio * 100 }),
        ratio,
    }));
    React.useEffect(() => void dispatch(actions.stats.pastDuePsm()), []);

    return <DataMultiDisplayCard fetching={pastDuePsm.fetching} name={t('title')} data={data} mode='bar' />;
};
